import AxiosProvider from '@/app/utils/api/axios-provider';
import { AxiosResponse } from 'axios';

export default {
  /**
   * Sub-datasources (in upload order) a Validate run needs a data file for.
   * Shared by the attribute and filter Validate tabs.
   */
  getValidateDatasourceInfo(
    clientId: number,
    dataSourceName: string
  ): Promise<AxiosResponse> {
    return AxiosProvider.amsApiClient.get(
      `/clients/${clientId}/validate-datasource-info`,
      { params: { dsName: dataSourceName } }
    );
  },
};
